var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeeListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "badge_FILL1_wght400_GRAD0_opsz48",
    d: "M18.243,14.192a.563.563,0,1,0,0-1.125h-2.7a.563.563,0,1,0,0,1.125Zm0,2.542a.563.563,0,1,0,0-1.125h-2.7a.563.563,0,1,0,0,1.125ZM15.34,8.5h5.31A1.384,1.384,0,0,1,22,9.85v10.8A1.384,1.384,0,0,1,20.65,22H5.35A1.384,1.384,0,0,1,4,20.65V9.85A1.384,1.384,0,0,1,5.35,8.5h5.332V5.35A1.384,1.384,0,0,1,12.032,4H13.99a1.384,1.384,0,0,1,1.35,1.35ZM12.032,9.85H13.99V5.35H12.032Zm-1.867,5.76a1.192,1.192,0,1,0-.866-.349,1.176,1.176,0,0,0,.866.349ZM7.42,18.242H12.8v-.315a1.3,1.3,0,0,0-.2-.72,1.017,1.017,0,0,0-.517-.427,9.033,9.033,0,0,0-1.125-.326,4.122,4.122,0,0,0-.788-.079,4.457,4.457,0,0,0-.911.1,9.935,9.935,0,0,0-1.091.3,1.008,1.008,0,0,0-.54.427,1.3,1.3,0,0,0-.2.72Z",
    transform: "translate(-4 -4)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeListIcon);
export default __webpack_public_path__ + "static/media/EmployeeListIcon.162509b879c066fe770f2fadeec4f7d5.svg";
export { ForwardRef as ReactComponent };